import { DurationIcon } from "@xola/icons";
import { Badge, Tooltip } from "@xola/ui-kit";
import React from "react";

interface PendingBadgeCountProps {
    pendingCount: number;
}

export const PendingBadgeCount = ({ pendingCount }: PendingBadgeCountProps) => (
    <Tooltip
        content={
            <span>
                <var data-var="pendingCount">{pendingCount}</var> reservations have not been confirmed
            </span>
        }
    >
        <Badge color="problem" size="small" className="text-black">
            <DurationIcon className="top-0 mr-1" />
            <span>
                <var data-var="pendingCount">{pendingCount}</var> Pending
            </span>
        </Badge>
    </Tooltip>
);
